import type { ComponentKey, Process } from "@certa/studio-core";
import type { ZodRawProcess } from "@certa/queries/schemas/studio/deployableJSON.schema";

export type ImportMetaJSON = (props: {
  metaJSON: Process;
  processId: string;
  config?: {
    shouldSkipDeleteProcess?: boolean;
    shouldSkipUpdatingModifiedAtTimestamp?: boolean;
    shouldLogChangesInLedgerAndUndoStack?: boolean;
    shouldSkipClearingPreviousLedgerAndUndoRedoStack?: boolean;
  };
}) => void;

export type ReplaceMetaJSON = (props: {
  metaJSON: Process;
  processId: string;
  config?: {
    shouldSkipUpdatingModifiedAtTimestamp?: boolean;
    shouldLogChangesInLedgerAndUndoStack?: boolean;
    shouldSkipClearingPreviousLedgerAndUndoRedoStack?: boolean;
  };
}) => void;

export type ForwardParse = (props: {
  metaJSON: Process;
  shouldIgnoreInvalidReferences?: boolean;
}) => ZodRawProcess;

export type ReverseParse = (props: {
  deployableJSON: ZodRawProcess;
  processId: string;
}) => Process;

export type HighlightChangedComponents = (props: {
  updatedComponentTags: string[];
  addedComponentTags: string[];
  deletedComponentTags: string[];
}) => void;

export type GetComponentDetailsReturnType = {
  componentData?: NodeDetails;
  componentAncestorsData?: ComponentParentsDetails;
};

export type NodeDetails = {
  type: StudioNodeType;
  id: string;
  tag: string;
  data: any; // TODO: Define the data type
  position?: NodePosition;
};

export type NodePosition = {
  x: number;
  y: number;
  height: number;
  width: number;
};

// Naming could be better but changing it to avoid same name as in processDesigner
export enum StudioNodeType {
  STEP = "Step",
  SWIMLANE = "Swimlane",
  FIELD = "Field"
}

export type ComponentParentsDetails = {
  [StudioNodeType.SWIMLANE]?: NodeDetails; // will be undefined for swimlane
  [StudioNodeType.STEP]?: NodeDetails; // will be undefined for swimlane and step
};

/** Focus Commponent In View Types */
export type FocusNodeConfig = {
  xOffset?: number;
  yOffset?: number;
};

type FocusComponentInViewCommonProps = {
  componentType:
    | ComponentKey.SWIMLANES
    | ComponentKey.STEPS
    | ComponentKey.FIELDS;
  config?: FocusNodeConfig;
};

type FocusComponentInViewParamsWithId = {
  componentId: string;
} & FocusComponentInViewCommonProps;

type FocusComponentInViewParamsWithTag = {
  processId: string;
  componentTag: string;
} & FocusComponentInViewCommonProps;

export type FocusComponentInViewProps =
  | FocusComponentInViewParamsWithId
  | FocusComponentInViewParamsWithTag;
/** Focus Commponent In View Types */
